import { MARQUEE_ITEMS } from "@/data/content";

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-slateblue/15 bg-white/60 py-5"
    >
      <div className="animate-marquee flex w-max items-center whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-lg sm:text-xl text-navy/80 px-6">{item}</span>
            <svg viewBox="0 0 24 24" className="h-2.5 w-2.5 text-gold shrink-0" fill="currentColor" aria-hidden="true">
              <path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" />
            </svg>
          </span>
        ))}
      </div>
    </div>
  );
}
